module.exports = __webpack_public_path__ + "static/media/hire.2b844452.svg";